import styled from 'styled-components';

export const LayoutContainer = styled.div`
  margin-top: 8rem;
`;

export const LayoutContainerV2 = styled.div`
  margin-top: 0;
`;
